export enum ReportName{
    CustomerExperienceDashboard = 'CustomerExperienceDashboard',
    CreditLimit = 'CreditLimit',
    Dashboard = 'Dashboard',
    OrderStatus = 'OrderStatus',
    Disputes = 'Disputes'
}

